import {DbCollectionFactory} from "factories/DbCollectionFactory.js";
import {DB_COLLECTION_NAMES} from "constants/AppConstants.js";
import IdGeneratorUtil from "utils/IdGeneratorUtil.js";

const navigationFactory: any = DbCollectionFactory.create(DB_COLLECTION_NAMES.navs);
const pointFactory: any = DbCollectionFactory.create(DB_COLLECTION_NAMES.points);

/** Writes a parsed activity (from GPX/FIT/VKX import) to RTDB and the local mirror — the same
 * write sequence ImportGPXButton/ImportFITButton/ImportVKXButton each already do inline, factored
 * out so ImportBridgeListener (native-triggered import) can reuse it without duplicating it a
 * fourth time. */
export const finalizeImportedActivity = async (
  activityDb: any,
  pointsDb: any,
  userUid: string,
  addNavigationsToState: (navs: any[], a: boolean, b: boolean) => void
): Promise<void> => {
  const key = IdGeneratorUtil.generateUuid();
  await pointFactory.addPointsByNavIdAsync(userUid, key, pointsDb);
  activityDb.ID = key;
  activityDb.idF = key;
  await navigationFactory.addNavigationAsync(userUid, activityDb, key);

  addNavigationsToState([activityDb], true, true);
};
